<template>
  <div class="g-update-layout site-update">
    <!-- 标题 -->
    <div class="g-update-layout-title" v-if="AUTH_SITE_ADD || AUTH_SITE_EDIT">
      <h3>
        {{
          stationId
            ? stationInfo && stationInfo && stationInfo.info && stationInfo.info.name
              ? stationInfo.info.name
              : ''
            : $t('com_sider_menu_site_add')
        }}
      </h3>

      <div class="g-upadte-layout-btn">
        <a-button
          type="default"
          @click="
            () => {
              this.$router.go(-1);
            }
          "
        >
          {{ $t('site_btn_back') }}
        </a-button>

        <a-button type="primary" @click="onSubmit" :loading="loading">
          {{ $t('site_btn_info') }}
        </a-button>
      </div>
    </div>

    <!-- 内容 -->
    <div class="g-update-layout-content site-update-content">
      <!-- 设备不存在，查询ID获取信息失败 -->
      <NoAuth v-if="!(AUTH_SITE_ADD || AUTH_SITE_EDIT)" />

      <!-- 编辑时内容为空 -->
      <div v-else-if="stationId && !stationInfo">
        <Empty />
      </div>

      <!-- 编辑/添加表单 -->
      <a-form-model
        :model="form"
        :rules="rules"
        ref="addSiteForm"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 18 }"
        style="width:760px;"
        v-else
      >
        <!-- 所属客户 -->
        <a-form-model-item :label="$t('site_form_belong_customer')" prop="customerId">
          <a-select
            :getPopupContainer="triggerNode => triggerNode.parentNode"
            v-model="form.customerId"
            :placeholder="$t('site_form_belong_customer_placeholder')"
            show-search
            allowClear
            :disabled="formByCustomer"
            :filter-option="
              (input, option) => {
                return (
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                );
              }
            "
          >
            <a-select-option
              :value="customer.customerId"
              v-for="customer in customerList"
              :key="customer.customerId"
            >
              {{ customer.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          :label="$t('com_form_region_area_label')"
          class="site-update-regin-area"
          :rules="[
            {
              required: true,
              message: $t('com_form_area_select'),
              trigger: 'change',
            },
          ]"
        >
          <!-- 地区 -->
          <a-form-model-item
            :label="null"
            prop="areaId"
            style="margin-bottom:0"
            class="site-update-area"
          >
            <a-select
              :getPopupContainer="triggerNode => triggerNode.parentNode"
              v-model="form.areaId"
              :placeholder="$t('com_form_area_select')"
              show-search
              allowClear
              :filter-option="filterOption"
              @change="areaChange()"
            >
              <a-select-option :value="area.id" v-for="area in areaList" :key="area.id">
                {{ area.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <!-- 国家 -->
          <a-form-model-item
            :label="null"
            prop="regionId"
            style="margin:0 0 0 10px;"
            v-if="form.areaId"
            class="site-update-region"
          >
            <a-select
              :getPopupContainer="triggerNode => triggerNode.parentNode"
              v-model="form.regionId"
              :placeholder="$t('com_form_region_select')"
              show-search
              :filter-option="filterOption"
              allowClear
            >
              <a-select-option :value="country.id" v-for="country in countryList" :key="country.id">
                {{ country.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model-item>

        <!-- 名称 -->
        <a-form-model-item :label="$t('site_form_name')" prop="name">
          <a-input
            v-model="form.name"
            style="min-width:200px"
            :placeholder="$t('site_form_name_placeholder')"
            allowClear
          />
        </a-form-model-item>

        <!-- 图片 -->
        <a-form-model-item :label="$t('site_form_image')" prop="icons" style="width:100%;">
          <UploadOSS
            :value="form.icons"
            :manuallyUpload="false"
            @change="
              fileList => {
                form.icons = fileList || [];
              }
            "
            :maxCount="1"
            ref="uploadFile"
            uploadDirInOSS="images"
            uploadType="image"
          />
        </a-form-model-item>

        <!-- 建站时间 -->
        <a-form-model-item :label="$t('site_info_build_date')" prop="buildDate">
          <a-date-picker v-model="form.buildDate" />
        </a-form-model-item>

        <!-- 站点编号 -->
        <!-- <a-form-model-item :label="$t('site_form_code')" prop="code">
          <a-input
            v-model="form.code"
            style="min-width:200px"
            :placeholder="$t('site_form_code_placeholder')"
            allowClear
          />
        </a-form-model-item> -->

        <!-- 通知接收人 -->
        <a-form-model-item :label="$t('site_info_notification')" prop="receiveUsers">
          <a-select
            :getPopupContainer="triggerNode => triggerNode.parentNode"
            v-model="form.receiveUsers"
            :placeholder="$t('site_form_notification_placeholder')"
            show-search
            mode="multiple"
            :filter-option="
              (input, option) => {
                return (
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                );
              }
            "
          >
            <a-select-option
              :value="customer.userId"
              v-for="customer in receiveUsers"
              :key="customer.userId"
            >
              {{ customer.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <!-- 地址 -->
        <a-form-model-item :label="$t('site_info_address')" prop="instAddress">
          <a-input
            type="textarea"
            v-model="form.instAddress"
            style="min-width:200px;"
            :placeholder="$t('site_form_address_placeholder')"
            rows="3"
            allowClear
          />
        </a-form-model-item>

        <!-- 联系人 -->
        <!-- <a-form-model-item :label="$t('site_form_contact')" prop="code">
          <a-input
            v-model="form.contact"
            style="min-width:200px"
            :placeholder="$t('site_form_contact_placeholder')"
            allowClear
          />
        </a-form-model-item> -->

        <!-- 联系电话 -->
        <!-- <a-form-model-item :label="$t('site_form_phone')" prop="code">
          <a-input
            v-model="form.phone"
            style="min-width:200px"
            :placeholder="$t('site_form_phone_placeholder')"
            allowClear
          />
        </a-form-model-item> -->

        <!-- 备注 -->
        <a-form-model-item :label="$t('com_form_description')" prop="description">
          <a-input
            type="textarea"
            v-model="form.description"
            style="min-width:200px;"
            :placeholder="$t('com_form_description_placeholder')"
            rows="5"
            allowClear
          />
        </a-form-model-item>

        <!-- 错误描述 -->
        <div class="form-error-text">
          <Icon type="error" v-if="formError" />
          <p>{{ formError }}</p>
        </div>
      </a-form-model>
    </div>
  </div>
</template>
<script>
import * as API from '@/api/site';
import * as CustomerAPI from '@/api/system/customer';
// mixins
import commonMixin from '@/mixins/common';
import cusomterMixin from '@/mixins/customer';
import areaMixin from '@/mixins/area';
import moment from 'moment';
import siteAuth from '@/views/site/mixins/siteAuth';

export default {
  mixins: [commonMixin, cusomterMixin, areaMixin, siteAuth],
  data() {
    return {
      stationId: null,
      stationInfo: null,

      rules: {
        customerId: [
          {
            required: true,
            message: this.$t('site_form_belong_customer_placeholder'),
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: this.$t('site_form_name_placeholder'),
            trigger: 'change',
          },
        ],
        buildDate: [
          {
            required: true,
            message: this.$t('site_form_build_date_placeholder'),
            trigger: 'change',
          },
        ],
        areaId: [
          {
            required: true,
            message: this.$t('com_form_area_select'),
            trigger: 'change',
          },
        ],

        regionId: [
          {
            required: true,
            message: this.$t('com_form_region_select'),
            trigger: 'change',
          },
        ],
        // code: [
        //   {
        //     required: true,
        //     message: this.$t('com_form_code_placeholder'),
        //     trigger: 'change',
        //   },
        // ],
      },
      // 搜索
      form: {
        name: undefined,
        buildDate: undefined,
        customerId: undefined,
        areaId: undefined,
        regionId: undefined,
        instAddress: undefined,
        receiveUsers: undefined,
        description: undefined,
        icons: undefined,
      },

      formError: '',

      formIsEdit: false,
      formByCustomer: false,
      customerInfo: null,

      loading: false,

      // 通知接收人
      receiveUsers: [],
    };
  },
  created() {
    // 编辑
    if (this.$route && this.$route.params && this.$route.params.id) {
      this.stationId = this.$route.params.id;
    }

    // 从customer过来添加
    if (this.$route && this.$route.query && this.$route.query.customerId) {
      this.formByCustomer = true;
      this.form.customerId = this.$route.query.customerId;
    }

    this.getData();
  },
  methods: {
    // 获取表单数据
    getData() {
      const _list = [this.getAllCustomerList(), this.getAreaList()];

      // 编辑时，获取一次站点信息
      if (this.stationId) {
        _list.push(this.getSiteDetail());
      }

      // 从customer过来
      if (this.formByCustomer) {
        _list.push(this.getCustomerDetail());
      }

      // 获取通知接收人
      _list.push(this.getReceiveUsers());

      Promise.all(_list).finally(() => {
        if (this.formByCustomer) {
          // 从customer过来
          this.form.areaId = this.customerInfo.areaId;
        }
        // 更新area/region
        this.getCountryList(this.form.areaId);

        if (this.formByCustomer) {
          this.form.regionId = this.customerInfo.regionId;
        }

        // 全部接口返回时，清除loading
        this.$store.commit('setPageLoading', false);
      });
    },

    // 获取站点详情
    getSiteDetail() {
      return API.SiteDetail({
        stationId: this.stationId,
      }).then(res => {
        if (res.code === 0) {
          try {
            this.stationInfo = res.data;

            Object.keys(this.form).forEach(key => {
              if (key === 'receiveUsers') {
                // 通知接收人
                this.form[key] = (this.stationInfo.receiveUsers || []).map(item => item.userId);
              } else {
                this.form[key] = this.stationInfo.info[key];
              }
            });
            if (this.form.buildDate) {
              this.form.buildDate = moment(this.form.buildDate);
            }
          } catch (err) {
            console.error(err);
          }

          // 记录当前站点路由
          // this.$store.commit('setHistoryRouteList', {
          //   ...this.$route,
          // });
        }
      });
    },

    // 获取客户信息
    getCustomerDetail() {
      return CustomerAPI.CustomerDetail({
        customerId: this.form.customerId,
      }).then(res => {
        if (res.code === 0) {
          this.customerInfo = res.data.customerInfo;
        }
      });
    },

    // 获取接收通知人列表
    getReceiveUsers() {
      return API.SiteNotifyUsers().then(res => {
        if (res.code === 0) {
          this.receiveUsers = res.data || [];
        }
      });
    },

    // 提交
    onSubmit() {
      this.$refs.addSiteForm.validate(valid => {
        if (valid) {
          try {
            const params = { ...this.form };

            // 指定字段，格式化两边的空格
            for (const key in params) {
              if (['buildDate'].includes(key)) {
                params[key] = new Date(params[key]).getTime();
              }
            }

            this.loading = true;

            // 编辑
            if (this.stationId) {
              params.stationId = this.stationId;
              API.SiteEdit(params)
                .then(res => {
                  if (res && res.code === 0) {
                    // 保存成功
                    this.$success({
                      title: this.$t('com_msg_edit_success'),
                      onOk: () => {
                        // 返回详情
                        this.$router.push({
                          name: 'SiteDetail',
                          params: {
                            id: this.stationId,
                          },
                        });
                      },
                    });
                  } else {
                    this.$error({
                      title: this.$t('com_msg_edit_fail'),
                    });
                  }
                })
                .finally(() => {
                  this.loading = false;
                });
            } else {
              API.SiteAdd(params)
                .then(res => {
                  if (res && res.code === 0) {
                    // 保存成功
                    this.$success({
                      title: this.$t('com_msg_add_success'),
                      onOk: () => {
                        // 返回列表
                        this.$router.push({
                          name: 'SiteList',
                        });
                      },
                    });
                  } else {
                    this.$error({
                      title: this.$t('com_msg_add_fail'),
                    });
                  }
                })
                .finally(() => {
                  this.loading = false;
                });
            }
          } catch (err) {
            console.log('err', err);
          }
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.site-update {
  // 内容
  .site-update-content {
    overflow-y: auto;
    ::v-deep .site-update-regin-area {
      .site-update-area {
        min-width: 260px;
      }

      .site-update-region {
        min-width: 200px;
      }

      .ant-form-item-children {
        display: flex;
        align-items: flex-start;
        padding-top: 5px;
      }
    }
  }
}
</style>
